import React from 'react';
import { UserAddOutlined } from '@ant-design/icons';
import {
    Input,
    Select,
    Button,
} from '@clockout-dev/design-elements';
import SectionCard from '../../common/sectionCard/SectionCard';
import styles from '../styles/team.module.scss';
import FormError from '../../common/formError/FormError';

function InviteTeamMembersCard({
    email,
    role,
    roleOptions,
    onEmailChange,
    onRoleChange,
    onSubmit,
    loading,
    errorMessage,
}) {
    const hasError = Boolean(errorMessage);

    return (
        <SectionCard icon={<UserAddOutlined />} title="Invite Team Members">
            <form className={styles.inviteForm} onSubmit={onSubmit} noValidate>
                <FormError id="invite-email-error" error={errorMessage} />

                <Input
                    id="invite-email"
                    type="email"
                    label="Email"
                    size="m"
                    labelSize="s"
                    placeholder="name@yourbank.com"
                    value={email || ''}
                    onChange={(e) => onEmailChange && onEmailChange(e.target.value)}
                    autoComplete="email"
                    status={hasError ? 'error' : ''}
                    aria-invalid={hasError || undefined}
                    aria-describedby={hasError ? 'invite-email-error' : undefined}
                />

                <Select
                    id="invite-role"
                    label="Assign Role"
                    size="m"
                    labelSize="s"
                    value={role || 'Member'}
                    options={roleOptions}
                    onChange={(value) => onRoleChange && onRoleChange(value)}
                />

                <Button
                    type="submit"
                    size="m"
                    variant="primary"
                    color="secondary"
                    fontWeight="bold"
                    disabled={loading}
                    className={styles.sendInviteButton}>
                    {loading ? 'Sending...' : 'Send Invite'}
                </Button>
            </form>
        </SectionCard>
    );
}

export default InviteTeamMembersCard;
